module.exports = __webpack_public_path__ + "img/banner2.8ecfaf68.png";